const items = [
  "Réparation mécanique",
  "Entretien courant",
  "Diagnostic électronique",
  "Montage pneumatique",
  "Véhicules d'occasion",
  "Dépôt-vente",
  "Convoyage auto",
  "Véhicule de prêt",
  "Location de véhicule",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-border bg-card/60 py-4"
      data-testid="marquee-strip"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-8">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-8 whitespace-nowrap font-display text-sm font-semibold uppercase tracking-[0.3em] text-muted-foreground"
          >
            {item}
            <span className="text-primary">//</span>
          </span>
        ))}
      </div>
    </div>
  );
};
